import { render, staticRenderFns } from "./VwaLedSign.vue?vue&type=template&id=0c17f730&scoped=true&"
import script from "./VwaLedSign.vue?vue&type=script&lang=ts&"
export * from "./VwaLedSign.vue?vue&type=script&lang=ts&"
import style0 from "./VwaLedSign.vue?vue&type=style&index=0&id=0c17f730&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c17f730",
  null
  
)

export default component.exports